/**
 * A Composable that autoscroll to a register element.
 * It's not designed to scroll *immediately* but only after livewire:navigated
 */
export const useAutoScroll = () => {
    // state of scroll request
    const state = {
        selector: "", // the text selector for document.querySelector
        element: null, // the element, returned by document.querySelector
        yOffset: 0, // an absolute offset
    };
    /**
     * private function that scroll the body to a calculated position
     */
    const _scroll = () => {
        if (state.element) {
            const rect = state.element.getBoundingClientRect();
            document.documentElement.scrollTop = rect.top + state.yOffset;
        }
    };

    /**
     * Request a scroll to the selector, to occurs after livewire:navigated.
     * @param {string} selector
     * @param {number} yOffset
     */
    const scrollTo = (selector, yOffset = 0) => {
        state.selector = selector;
        state.element = document.querySelector(state.selector);
        state.yOffset = yOffset ?? 0;
        _scroll();
    };

    return {
        scrollTo,
    };
};
